import ResponsiveHeader from '@/components/sections/ResponsiveHeader/ResponsiveHeader.vue';

// @vue/component
export default {
  props: {
  },
  components: {
    ResponsiveHeader,
  },
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
  },
};
